/**
 * 
 * About.js
 * 
 */

 import React, { Component } from 'react'

 // component
 import LRWrapper from '../../common/LRWrapper'; 
 import Left from './left/Left';
 import Right from './right/Right';

 
 export default class About extends Component {

    static displayName = About.name;

     
    render() {

         return (

             <LRWrapper id="about" bg_image="/assets/image/background/2.png">
                <Left />
                <Right /> 
             </LRWrapper>

         );


     }


 }
 
